import { useState } from "react";
import { TabNav } from "../../../components/tabNav";
import { PageHeader } from "../../../components/typography/pageHeader";
import { SalesOverviewPage } from "./salesOverview";
import { SalesEarning } from "./salesEarnings";
import { SalesOrganizers } from "./salesOrganizers";
import {
  useGetDashboardMetricsQuery,
  useGetEarningsSummaryQuery,
  useGetSalesEventsQuery,
} from "../../../redux/features/sales/sales.api";
import { QueryParams } from "../../../utils/types";
import { useSearchParams } from "react-router-dom";

type SalesTabs = "overview" | "organizers" | "earnings";

export const SalesDashboardPage = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const activeTab = (searchParams.get("tab") as SalesTabs) || "overview";

  const [query, setQuery] = useState<QueryParams>({
    page: 1,
    limit: 50,
  });
  const { isFetching: fetchingMetrics, data: metrics } =
    useGetDashboardMetricsQuery(undefined, {
      refetchOnMountOrArgChange: true,
    });

  const { isFetching: fetchingSummary, data: earningSummary } =
    useGetEarningsSummaryQuery(undefined, {
      refetchOnMountOrArgChange: true,
    });

  const { isFetching: fetchingOverview, data: overviewData } =
    useGetSalesEventsQuery(
      {
        ...query,
        search: query.search === "" ? undefined : query.search,
      },
      {
        refetchOnMountOrArgChange: true,
      },
    );

  const totalEvents = overviewData?.data?.totalCount ?? 0;

  const tabs = [
    {
      title: "Overview",
      to: "overview",
      onClick: () => {
        setSearchParams({
          tab: "overview",
        });
      },
    },
    {
      title: "Organizers",
      to: "organizers",
      onClick: (selected: string) => {
        setSearchParams({
          tab: "organizers",
        });
      },
    },
    {
      title: "Earnings",
      to: "earnings",
      onClick: () => {
        setSearchParams({
          tab: "earnings",
        });
      },
    },
  ];

  return (
    <div className="w-full">
      <PageHeader
        header={`${activeTab === "overview" ? "Sales Overview" : activeTab === "organizers" ? "Organizers Invited" : "My Earnings"}`}
        className="!font-dela font-normal"
      />

      <TabNav
        navs={tabs}
        className="mt-8 !min-w-full md:!min-w-fit md:!max-w-fit"
        tabClassName=""
        activeTab={activeTab ?? "overview"}
        variant="switcher"
        theme="plain"
      />

      {activeTab === "overview" && (
        <SalesOverviewPage
          fetchingOverview={fetchingOverview}
          fetchingSummary={fetchingSummary}
          query={query}
          setQuery={setQuery}
          earningSummary={earningSummary?.data}
          overviewData={overviewData}
        />
      )}
      {activeTab === "organizers" && (
        <SalesOrganizers
          fetchingMetrics={fetchingMetrics}
          metrics={metrics}
          totalEvents={totalEvents}
        />
      )}

      {activeTab === "earnings" && (
        <SalesEarning
          metrics={metrics}
          earningSummary={earningSummary?.data}
          fetchingSummary={fetchingSummary}
        />
      )}
    </div>
  );
};
